<!--
 * @Date: 2025-02-07 14:56:21
 * @Description: Ai智能问答
-->
<template>
  <div class="h-full">
    <el-row :gutter="10" class="h-full text-14px">
      <el-col :span="6" class="h-full">
        <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
          <div class="border-l-3 border-color-primary flex-1 pl-10px text-16px mb-20px">
            最近问答
          </div>
          <div v-for="item in recentItems" :key="item.id">
            <div class="relative pt-16px leading-18px">
              {{ item.content }}
              <span class="text-12px text-[#999] absolute right-0 top-0"
                >{{ item.time }}分钟前</span
              >
            </div>
            <el-divider class="my-10px"></el-divider>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12" class="h-full">
        <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }"></el-card>
      </el-col>
      <el-col :span="6" class="h-full">
        <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
          <div class="border-l-3 border-color-primary flex-1 pl-10px text-16px mb-20px">
            热门问答
          </div>
          <div v-for="item in hotAnsItems" :key="item.id">
            <div class="relative pt-16px leading-18px">
              {{ item.content }}
              <span class="text-12px text-[#999] absolute right-0 top-0">{{ item.num }}</span>
            </div>
            <el-divider class="my-10px"></el-divider>
          </div>
          <div class="mt-100px">
            <div class="border-l-3 border-color-primary flex-1 pl-10px text-16px mb-20px">
              提问帮助
            </div>
            <div v-for="item in helpsItems" :key="item.id">
              <div>
                {{ item.content }}
              </div>
              <el-divider class="my-10px"></el-divider>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'aiIntelligent',
  data() {
    return {
      recentItems: [
        { id: 1, content: '条目一', time: 5 },
        { id: 2, content: '条目二', time: 10 },
        { id: 3, content: '条目三', time: 15 },
        { id: 4, content: '条目四', time: 20 },
        { id: 5, content: '条目五', time: 35 },
      ],
      hotAnsItems: [
        { id: 1, content: '当前资产共有多少？', num: 500 },
        { id: 2, content: '当前资产共有多少？', num: 500 },
        { id: 3, content: '当前资产共有多少？', num: 500 },
        { id: 4, content: '当前资产共有多少？', num: 500 },
        { id: 5, content: '当前资产共有多少？', num: 5000 },
      ],
      helpsItems: [
        { id: 1, content: '如何准确提问？' },
        { id: 2, content: '当前资产共有多少？' },
        { id: 3, content: '当前资产共有多少？' },
        { id: 4, content: '当前资产共有多少？' },
        { id: 5, content: '当前资产共有多少？' },
      ],
    }
  },
  watch: {},
  created() {},
  methods: {},
}
</script>

<style lang="scss" scoped>

</style>
